import { lazy, Suspense, useEffect, useRef, useState } from "react";

/**
 * 滚近可视区域后再动态 import 子模块，避免首屏打包/解析下方大图依赖。
 */
function DeferredMount({
  loader,
  rootMargin = "280px 0px",
  fallback = null,
  className,
}) {
  const hostRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [LazyChild] = useState(() => lazy(loader));

  useEffect(() => {
    const node = hostRef.current;
    if (!node || shouldLoad) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setShouldLoad(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [shouldLoad, rootMargin]);

  return (
    <div ref={hostRef} className={className}>
      {shouldLoad ? (
        <Suspense fallback={fallback}>
          <LazyChild />
        </Suspense>
      ) : (
        fallback
      )}
    </div>
  );
}

export default DeferredMount;
